
import React from "react";
import { cn } from "@/lib/utils";

interface RemixIconProps {
  name: string;
  className?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "1x" | "2x" | "3x" | "4x" | "5x" | "6x" | "7x" | "8x" | "9x" | "10x";
  fill?: boolean;
  flip?: "horizontal" | "vertical";
  rotate?: 90 | 180 | 270;
  color?: string;
}

export const RemixIcon = ({ 
  name, 
  className, 
  size = "md", 
  fill = false, 
  flip, 
  rotate,
  color
}: RemixIconProps) => {
  const classes = cn(
    "ri",
    `ri-${name}`,
    {
      [`ri-${size}`]: size,
      "ri-fw": true, // fixed width
      [`ri-flip-${flip}`]: flip,
      [`ri-rotate-${rotate}`]: rotate,
      "ri-fill": fill,
    },
    className
  );

  return <i className={classes} style={color ? { color } : undefined} />;
};
